<div class="container">
  <div class="logo-container">
    <div class="logo">
      <img width="205px" [src]="'../../../../../assets/Hayrick/logo/'+subdomain+'/logo-light.svg'" alt="hayrick logo" />
    </div>
  </div>

  <div class="card">
    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navSubmitMobileBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>
    </div>
    <div class="title-container">

      <h1 class="title-2">Forgot Passcode</h1>
    </div>


    <div class="text-container">
      <p class="text-1">Enter your mobile number and click submit.</p>

    </div>

    <div class="input-box">
      <form [formGroup]="fpSubmitMobileForm">
        <div class="input-container">
          <input type="tel"
          id="mobileSignin"
          name="phone" onkeyup="this.value = this.value.replace(/[^0-9-]/g, '');"
          placeholder="Mobile number"
          formControlName="phone"
          appIntlTelInput class="custom" />

        </div>
      </form>


    </div>

    <div class="signinbutton">
      <button [disabled]="fpSubmitMobileForm.invalid" (click)="onSubmitMobileClick()" class="sign-in-button">Submit</button>
    </div>


  </div>
</div>
